<div class="main-content" class="dx-viewport">
  <div class="container-fluid">

    <div class="row" [hidden]="loadingVisible">
      <div class="col-md-12 mt-3">
        <div class="row">

          <div class="col-md-3 field-container">
            <form [formGroup]="form" (ngSubmit)="onSubmit()">
              <mat-form-field appearance="outline">
                <mat-label>
                  Filtrar por trabajador:
                </mat-label>
                <mat-select name="workers" [(ngModel)]="workersFilter" formControlName="workers" multiple
                  (ngModelChange)="$event && onSubmit()">
                  <mat-option *ngFor="let worker of workers" [value]="worker._id">
                    {{worker.firstname}} {{worker.lastname}}
                  </mat-option>
                </mat-select>
              </mat-form-field>
            </form>
            <span class="field-actions" *ngIf="workersFilter.length > 0">
              <button type="button" class="btn btn-link text-danger mx-0 p-1" (click)="resetFilter()">
                <i class="material-icons">clear</i>
              </button>
            </span>
          </div>

          <div class="col-md-9">
            <mat-label>

            </mat-label>
            <div>
              Filtrar trabajos por estado: <br>
              <button mat-raised-button class="m-0 ml-1 p-1 px-2 btn"
                [ngStyle]="{'background-color': colorStatusScheduled}"
                (click)="statusFilter = 'SCHEDULED'; filterAppointments()">Programados</button>
              <button mat-raised-button class="m-0 ml-1 p-1 px-2 btn"
                [ngStyle]="{'background-color': colorStatusOnGoing}"
                (click)="statusFilter = 'ONGOING'; filterAppointments()">En Curso</button>
              <button mat-raised-button class="m-0 ml-1 p-1 px-2 btn"
                [ngStyle]="{'background-color': colorStatusCompleted}"
                (click)="statusFilter = 'COMPLETED'; filterAppointments()">Completados</button>
              <button mat-raised-button class="m-0 ml-1 p-1 px-2 btn"
                [ngStyle]="{'background-color': colorStatusInvoiced}"
                (click)="statusFilter = 'INVOICED'; filterAppointments()">Facturados</button>
              <button mat-raised-button class="m-0 ml-1 p-1 px-2 btn"
                [ngStyle]="{'background-color': colorStatusCancelled}"
                (click)="statusFilter = 'CANCELLED'; filterAppointments()">Cancelados</button>
              <button mat-raised-button class="m-0 ml-1 p-1 px-2 btn"
                (click)="statusFilter = ''; filterAppointments()">Todos</button>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-md-12">
        <div>
          <dx-load-panel #loadPanel shadingColor="rgba(0,0,0,0.4)" [position]="{ of: '#calendar' }"
            [(visible)]="loadingVisible" [showIndicator]="true" [showPane]="true" [shading]="true"
            [hideOnOutsideClick]="false">
          </dx-load-panel>
        </div>

        <dx-scheduler appointmentTemplate="appointment-template" [height]="700" [currentDate]="currentDate"
          [dataSource]="appointmentsData" currentView="timelineDay" [startDayHour]="0" [endDayHour]="23"
          [cellDuration]="60" [allDayPanelMode]="'all'" [groups]="['worker']" *ngIf="!loadingVisible && workers.length > 0"
          (onOptionChanged)="onOptionChanged($event)" (onAppointmentFormOpening)="onAppointmentFormOpening($event)"
          (onContentReady)="onContentReady($event)" [crossScrollingEnabled]="true">
          <dxo-editing #editingOptions [allowAdding]="false" [allowDeleting]="false" [allowUpdating]="false"
            [allowResizing]="false" [allowDragging]="false"></dxo-editing>

          <div *dxTemplate="let appointment of 'appointment-template'"
            [ngStyle]="{ backgroundColor: appointment.targetedAppointmentData.color }">
            <div>
              {{ appointment.targetedAppointmentData.cTitle}}
            </div>
          </div>

          <dxi-view type="timelineDay" name="Día" groupOrientation="vertical"></dxi-view>
          <dxi-view type="week" groupOrientation="vertical"></dxi-view>
          <dxi-resource fieldExpr="worker" [dataSource]="workersV" label="worker" [allowMultiple]="true">
          </dxi-resource>
          <dxo-scrolling mode="virtual"> </dxo-scrolling>
        </dx-scheduler>

      </div>
    </div>

    <div [hidden]="loadingVisible" class="row">
    </div>

    <div *ngIf="!loadingVisible && workers.length == 0">
      <h2>No hay trabajadores asignados a servicios actualmente</h2>
    </div>
  </div>
</div>